<template>
    <div class="system-message" :class="{'appeal': isActionAppeal()}">
        <span>
            <template v-if="isActionVote()">
                <span class="player-seat-action pb-0 pt-0">
                    <span :style="{'color': player && typeof player !== 'undefined' ? player.color.code : ''}">
                        <span class="short-player-name">{{ getPlayerName(message.data.player_id) }}</span> &nbsp;
                    </span>
                    <template v-if="message.data.data && message.data.data.params && message.data.data.params.text">
                        {{ message.data.data.params.text }}
                    </template>
                    <template v-else>
                        {{ $t('message.voted') }}
                    </template>
                </span>
            </template>

            <template v-if="isActionJoin()">
                <span class="player-seat-action">
                    <span class="short-player-name">{{getPlayerOldColorName(message.data.data)}}</span>&nbsp;{{$t('message.joined_the_room')}}
                </span>
            </template>

            <template v-if="isActionTakeSeat()">
                <span class="player-seat-action">
                    <span class="short-player-name">{{ getPlayerOldColorName(message.data.data) }}&nbsp;</span>
                    {{ $t('message.took_seat') }}&nbsp;
                    <span :style="{'color': getPlayerColorCode(message.data.data)}"> {{ getPlayerColorName(message.data.data) }}&nbsp;</span>
                    {{ $t('message.seat') }}
                </span>
            </template>

            <template v-if="isActionChangeColor()">
                <span class="player-seat-action">
                    <span :style="{'color': getPlayerOldColorCode(message.data.data)}" class="short-player-name">{{ getPlayerName(message.data.player_id) }}&nbsp;</span>
                     {{$t('message.took_seat')}}&nbsp;
                    <span :style="{'color': getPlayerColorCode(message.data.data)}"> {{ getPlayerColorName(message.data.data) }}&nbsp;</span>
                     {{$t('message.seat')}}
                </span>
            </template>

            <template v-if="isActionRunTimer()">
                <span :style="{'color': player && typeof player !== 'undefined' ? player.color.code : ''}"
                      class="short-player-name">{{ getPlayerName(message.data.player_id) }}</span>&nbsp;
                <template v-if="message.data.data.params && message.data.data.params.is_timer">
                    {{ $t('message.run_timer') }}
                </template>
                <template v-else>
                    {{ $t('message.run_stopwatch') }}
                </template>

                {{ getTimerRangeString(message.data.data.params.range) }}
            </template>

            <template v-if="isActionAppeal()">
                <span :style="{'color': getPlayerColorCode(message.data.data)}" class="short-player-name">{{ getPlayerName(message.data.player_id) }}</span>,
                <template v-if="message.data.data.params && message.data.data.params.text">
                    {{ message.data.data.params.text }}
                </template>
            </template>

            <template v-if="isActionRestartGame()">
                <span class="player-seat-action">
                    <span :style="{'color': player && typeof player !== 'undefined' ? player.color.code : ''}" class="short-player-name">{{ getPlayerName(message.data.player_id) }}</span>&nbsp;
                    {{$t('message.player_restart_game')}}
                </span>
            </template>

            <template v-if="isActionBecomeGuest()">
                <span class="player-seat-action">
                    <span :style="{'color': getPlayerOldColorCode(message.data.data)}" class="short-player-name">{{ getPlayerOldColorName(message.data.data) }}&nbsp;</span>
                     {{$t('message.is_now')}}&nbsp;{{ getPlayerColorName(message.data.data) }}&nbsp;
                </span>
            </template>

            <template v-if="isActionDisconnected()">
                <span class="player-seat-action">
                    <span :style="{'color': getPlayerOldColorCode(message.data.data)}" class="short-player-name" v-once>{{ getPlayerOldColorName(message.data.data) }}</span>&nbsp;
                     {{$t('message.left_room')}}
                </span>
            </template>
        </span>
    </div>
</template>

<script>

import store from '../../../store';

const PLAYER_ACTION_VOTE = 1;
const PLAYER_ACTION_JOIN = 2;
const PLAYER_ACTION_CHANGE_COLOR = 3;
const PLAYER_ACTION_RUN_TIMER = 4;
const PLAYER_ACTION_APPEAL = 5;
const PLAYER_ACTION_RESTART_GAME = 6;
const PLAYER_ACTION_BECOME_GUEST = 7;
const PLAYER_ACTION_TAKE_SEAT = 8;
const PLAYER_ACTION_DISCONNECTED = 9;

export default {
    props: {
        message: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            PLAYER_ACTION_VOTE: PLAYER_ACTION_VOTE,
            PLAYER_ACTION_JOIN: PLAYER_ACTION_JOIN,
            PLAYER_ACTION_CHANGE_COLOR: PLAYER_ACTION_CHANGE_COLOR,
            PLAYER_ACTION_RUN_TIMER: PLAYER_ACTION_RUN_TIMER,
            PLAYER_ACTION_APPEAL: PLAYER_ACTION_APPEAL,
            PLAYER_ACTION_RESTART_GAME: PLAYER_ACTION_RESTART_GAME,
            PLAYER_ACTION_BECOME_GUEST: PLAYER_ACTION_BECOME_GUEST,
            PLAYER_ACTION_TAKE_SEAT: PLAYER_ACTION_TAKE_SEAT,
            PLAYER_ACTION_DISCONNECTED: PLAYER_ACTION_DISCONNECTED,
        }
    },

    mounted() {
        const tableHandInstance = window.PixiScene;

        if (tableHandInstance && (this.isActionChangeColor || this.isActionJoin)) {
            tableHandInstance.updatePlayerColor();
        }
    },

    computed: {
        player: function() {
            let currentPlayer;
            store.getters.getPlayers.forEach((player) => {

                if (this.message.data && player.id === this.message.data.player_id) {
                    currentPlayer = player;
                }
            });
            return currentPlayer;
        },
    },

    methods: {
        /**
         * Действие - игрок проголосовал
         */
        isActionVote()
        {
            return this.message.data.action === this.PLAYER_ACTION_VOTE;
        },

        /**
         * Действие - игрок присоединился
         */
        isActionJoin()
        {
            return this.message.data.action === this.PLAYER_ACTION_JOIN;
        },

        /**
         * Действие - игрок изменил цвет
         */
        isActionChangeColor()
        {
            return this.message.data.action === this.PLAYER_ACTION_CHANGE_COLOR;
        },

        /**
         * Действие - запуск таймера
         */
        isActionRunTimer()
        {
            return this.message.data.action === this.PLAYER_ACTION_RUN_TIMER;
        },

        /**
         * Действие - обращение
         */
        isActionAppeal()
        {
            return this.message.data.action === this.PLAYER_ACTION_APPEAL;
        },

        /**
         * Действие - игрок перезапустил игру
         */
        isActionRestartGame()
        {
            return this.message.data.action === this.PLAYER_ACTION_RESTART_GAME;
        },

        /**
         * Действие - игрок стал гостем
         */
        isActionBecomeGuest()
        {
            return this.message.data.action === this.PLAYER_ACTION_BECOME_GUEST;
        },

        /**
         * Действие - игрок занял сит
         */
        isActionTakeSeat()
        {
            return this.message.data.action === this.PLAYER_ACTION_TAKE_SEAT;
        },

        /**
         * Действие - игрок покинул комнату
         */
        isActionDisconnected()
        {
            return this.message.data.action === this.PLAYER_ACTION_DISCONNECTED;
        },

        /**
         * Имя игрока
         */
        getPlayerName(playerId)
        {
            let playersData = store.getters.getGameState.playersData;
            if (!playersData) {
                return null;
            }

            if (typeof playersData[playerId] === 'undefined') {
                return null;
            }

            return playersData[playerId].name;
        },

        /**
         * Цвет игрока
         * @param playerData
         * @return {*}
         */
        getPlayerColorName(playerData)
        {
            if (playerData && playerData.color_name) {
                return playerData.color_name;
            }

            if (!this.player || typeof this.player === 'undefined') {
                return null;
            }

            return this.player.color.name;
        },

        /**
         * Код цвета игрока
         * @param playerData
         * @return {*}
         */
        getPlayerColorCode(playerData)
        {
            if (playerData && playerData.color_code) {
                return playerData.color_code;
            }

            if (!this.player || typeof this.player === 'undefined') {
                return null;
            }

            return this.player.color.code;
        },

        /**
         * Старый цвет игрока
         * @param playerData
         * @return {*}
         */
        getPlayerOldColorName(playerData)
        {
            if (playerData && playerData.old_color_name) {
                return playerData.old_color_name;
            }

            if (!this.player || typeof this.player === 'undefined') {
                return null;
            }

            return this.player.color.name;
        },

        /**
         * Старый код цвета игрока
         * @param playerData
         * @return {*}
         */
        getPlayerOldColorCode(playerData)
        {
            if (playerData && playerData.old_color_code) {
                return playerData.old_color_code;
            }

            if (!this.player || typeof this.player === 'undefined') {
                return null;
            }

            return this.player.color.code;
        },

        /**
         * Вывод диапозона запуска таймера
         */
        getTimerRangeString(range)
        {
            if (!range || range.length !== 2) {
                return '';
            }

            if (range[0] < range[1]) {
                return this.$t('message.time_range', {
                    from: this.getTimeString(range[0]),
                    to: this.getTimeString(range[1])
                });
            }

            return this.$t('message.on_time') + ' ' + this.getTimeString(range[0]);
        },

        /**
         * Форматированное кол-во секунд
         */
        getTimeString(seconds)
        {
            if (!seconds) {
                return '';
            }

            let result = '';

            const min = Math.floor(seconds / 60);
            if (min > 0) {
                result += min + ' ' + this.$t('common.min') + ' ';
            }

            const sec = seconds% 60;
            if (sec > 0) {
                result += sec + ' ' + this.$t('common.sec');
            }

            return result;
        },
    }
}
</script>

<style scoped>

</style>
